import React from "react";
import JobCard from "./JobCard";
import { JobResult } from "../types/job"

interface JobCardListProps {
  results: any[]; // temporarily keep this loose
}
const JobCardList: React.FC<JobCardListProps> = ({ results }) => {
  console.log(":rocket: JobCardList received results:", results);
  return (
    <div className="job-card-list">
      {results.map((result, index) => (
        <JobCard key={index} result={result} />
      ))}
    </div>
  );
};
export default JobCardList;
